import { render, staticRenderFns } from "./goodBookOrder.vue?vue&type=template&id=b53c7e92&"
import script from "./goodBookOrder.vue?vue&type=script&lang=js&"
export * from "./goodBookOrder.vue?vue&type=script&lang=js&"
import style0 from "./goodBookOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports